import styled from 'styled-components';
import { comum } from '../../../../styles/Themes/light';

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c4a5568};
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 12px;
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-radius: 6px;
  font-size: 0.875rem;
  color: ${(props: any) => props.theme.colors.c2d3748};

  &::placeholder { color: ${(props: any) => props.theme.colors.ca0aec0}; }
  
  &:hover {
    border: 1px solid ${(props: any) => props.theme.colors.c000000};
  }

  &:focus {
    border: 1px solid ${(props: any) => props.theme.colors.c000000};
    outline: none;
  }
`;

// Estilos para os selects (seguindo padrão do StepServico)
export const selectStyles = {
  control: (provided: Record<string, unknown>, state: any) => ({
    ...provided,
    height: 48,
    boxShadow: "none",
    cursor: 'pointer',
    border: state.hasValue && state.selectProps.error 
      ? `1px solid ${comum.colors.primaryRed400}` 
      : '1px solid #EAEEF3',
    '&:hover': {
      border: '1px solid #000000',
    },
    '&:focus': {
      border: '1px solid #000000',
    },
  }),
  placeholder: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c353a40)',
    fontSize: '16px',
    fontWeight: '400',
  }),
  singleValue: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c353a40)',
    fontSize: '16px',
  }),
  option: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c5a646e)',
    fontSize: '16px',
    fontWeight: '500',
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 3,
  }),
  menuPortal: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 3,
  }),
};

export const selectTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: comum.colors.interfacePure100,
    primary50: comum.colors.interfacePure100,
    primary: comum.colors.interfacePure100,
  },
});

export const selectComponents = {
  IndicatorSeparator: () => null
};

export const AddButton = styled.button<{disabled?: boolean}>`
  height: 48px;
  padding: 0 16px;
  background-color: ${props => props.disabled ? 'var(--ccbd5e0)' : 'var(--ce52940)'};
  color: ${props => props.disabled ? 'var(--c9ca3af)' : 'white'};
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s;

  &:hover {
    ${props => props.disabled ? '' : 'transform: scale(1.05);'}
  }

  &:disabled {
    background-color: ${(props: any) => props.theme.colors.ccbd5e0};
    color: ${(props: any) => props.theme.colors.c9ca3af};
    transform: none;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;
  align-items: center;
  padding: 16px 20px;
  background-color: ${(props: any) => props.theme.colors.cf3f7fb};
  border: none;
  border-radius: 12px;

  /* Primeira div (Nome da parte) */
  > div:nth-child(1) {
    justify-self: start;
    text-align: left;
    min-width: 0;
  }

  /* Segunda div (Checkbox Representada) */
  > div:nth-child(2) {
    justify-self: center;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* Terceira div (Botão Excluir) */
  > div:nth-child(3) {
    justify-self: end;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    gap: 12px;
    padding: 16px;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    
    > div:nth-child(1) {
      grid-row: 1;
      margin-bottom: 8px;
    }
    
    > div:nth-child(2) {
      grid-row: 2;
      justify-self: start;
      margin-bottom: 8px;
    }
    
    > div:nth-child(3) {
      grid-row: 3;
      justify-self: end;
    }
  }
`;

export const CustomCheckbox = styled.div<{ checked: boolean }>`
  width: 22px;
  height: 22px;
  border: 2px solid ${props => props.checked ? 'var(--ce52940)' : 'var(--c798891)'};
  border-radius: 3px;
  background-color: ${props => props.checked ? 'var(--ce52940)' : 'var(--surface-input)'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  
  &::before {
    content: "✔";
    color: ${(props: any) => props.theme.colors.pureWhite};
    font-size: 14px;
    font-weight: bold;
    opacity: ${props => props.checked ? 1 : 0};
    transition: opacity 0.2s;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1;
  }
  
  &:hover {
    border-color: ${props => props.checked ? 'var(--cd41e35)' : 'var(--c000000)'};
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  
  span {
    color: ${(props: any) => props.theme.colors.c2d3748};
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1;
    flex-shrink: 0;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cfde8e8};
    transform: scale(1.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }

  svg path {
    fill: ${(props: any) => props.theme.colors.ce53e3e};
  }
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  background-color: ${(props: any) => props.theme.colors.cedf2f7};
  color: ${(props: any) => props.theme.colors.c2d3748};
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const ErrorText = styled.span`
  display: block;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  font-size: 0.8rem;
  margin-top: 6px;
`;


